import { z } from 'zod';

export const GenderCode = z.enum(['Z', 'M', 'F'], {
  required_error: 'Le genre est obligatoire.',
  invalid_type_error: 'Le genre doit être Z, M ou F.',
});

export type GenderCodeT = z.infer<typeof GenderCode>;
